import { transformDateValue } from 'core/js/FormUtils';
export const getInventoryitemView = (dataList) => {
  
  const transformDataValue = (value, type) =>{
    if (!type.includes('date')) return value;
    return transformDateValue(value);
  }

  let inventoryitemList = [];
  dataList.map((data)=>{
  let card = {
            'id': data.id,
            'headingList': [
                            {"fieldLabel":"title","fieldValue":transformDataValue(data.title,"string"), "fieldType":"string"},
                            {"fieldLabel":"Credit Count","fieldValue":transformDataValue(data.creditcount,"number"), "fieldType":"number"},
                            {"fieldLabel":"Debit Count","fieldValue":transformDataValue(data.debitcount,"number"), "fieldType":"number"},
                            {"fieldLabel":"Balance","fieldValue":transformDataValue(data.balance,"number"), "fieldType":"number"},
                            {"fieldLabel":"Product Id","fieldValue":transformDataValue(data.productid,"bodynamiclist"), "fieldType":"bodynamiclist"},
                            {"fieldLabel":"Product Name","fieldValue":transformDataValue(data.productname,"string"), "fieldType":"string"},
                            {"fieldLabel":"Ops","fieldValue":transformDataValue(data.ops,"string"), "fieldType":"string"},
                            {"fieldLabel":"Order Id","fieldValue":transformDataValue(data.orderid,"ID"), "fieldType":"ID"},
                            {"fieldLabel":"Party Name","fieldValue":transformDataValue(data.partyname,"string"), "fieldType":"string"},
              
              
            ],
            'dataList': [
                
              ]
          }

          inventoryitemList.push(card);
  })
  return inventoryitemList;
}